// src/templates/PageMetaDataContext.tsx
import React, { createContext } from 'react';
import { PageProps } from 'gatsby';

export type PageMetaType = {
    slug?: string;
    isBlogArticle?: boolean;
    blogTitle?: string;
    blogShortDescription?: string;
    displayPageName?: string;
    preferredLanguage?: string;
    location?: string | PageProps['location'];
    pagePaths?: { [key: string]: string };
    availableCountries?: string[];
};

type Props = {
    metadata: PageMetaType;
    children?: React.ReactNode;
};

// default context value (safe defaults)
export const PageMetadataContext = createContext<PageMetaType>({
    slug: undefined,
    isBlogArticle: false,
    blogTitle: undefined,
    blogShortDescription: undefined,
    displayPageName: undefined,
    preferredLanguage: undefined,
    location: undefined,
    pagePaths: {},
    availableCountries: [],
});

const PageMetadataProvider: React.FC<Props> = ({ metadata, children }) => {
    // NOTE: don't hold local state here so the provider always reflects
    // the latest metadata prop passed from the page.
    return (
        <PageMetadataContext.Provider value={metadata}>
            {children}
        </PageMetadataContext.Provider>
    );
};

export default PageMetadataProvider;
